// src/features/common/commonSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DashboardData {
  [key: string]: any;
}

interface CommonState {
  financialYr: string[];
  currentFinYear: string | null;
  selectedFinYear: string | null;
  currentClickedMenu: string;
  dashboardData: DashboardData;
  meetingType: any;
}

const initialState: CommonState = {
  financialYr: [],
  currentFinYear: null,
  selectedFinYear: "",
  currentClickedMenu: "States",
  dashboardData: {
    "Zilla Panchayats": {
      state_code: null,
      state_name: "",
      zp_lgd_code: null,
      zp_name: "",
    },
    "Block Panchayats": {
      state_code: null,
      state_name: "",
      zp_lgd_code: null,
      zp_name: "",
      bp_lgd_code: null,
      bp_name: "",
    },
    "Gram Panchayats": {
      state_code: null,
      state_name: "",
      zp_lgd_code: null,
      zp_name: "",
      bp_lgd_code: null,
      bp_name: "",
      gp_name: "",
      gp_lgd_code: null,
    },
    "Multilingual Coverage": {
      meeting_language: "",
      meeting_language_desc: "",
      taskId: "",
    },
  },
  meetingType: null,
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    getFinancialYr: (state) => {
      const years: string[] = [];
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1;
      //const currentDay = currentDate.getDate();
      const currentYear = currentDate.getFullYear();
      let actualStartYear = currentYear;
      //let actualEndYear = currentYear + 1;

      if (currentMonth < 4) {
        actualStartYear = currentYear - 1;
        //actualEndYear = currentYear;
      }
      //let visibleStartYear = actualStartYear;

      //const isEarlyFY =
      //  (currentMonth === 3 && currentDay >= 27) || currentMonth > 3;

      //if (isEarlyFY) {
      //  visibleStartYear = actualStartYear + 1;
      //}
      //for (let year = 2025; year <= visibleStartYear; year++) {
      for (let year = 2025; year <= actualStartYear; year++) {
        years.push(`${year}-${year + 1}`);
      }

      state.financialYr = years.reverse();
      //state.currentFinYear = `${actualStartYear}-${actualEndYear}`;
      state.currentFinYear = `${actualStartYear}-${actualStartYear + 1}`;
      // safety fix
      if (
        state.selectedFinYear &&
        !state.financialYr.includes(state.selectedFinYear)
      ) {
        state.selectedFinYear = "";
      }
    },

    setCurrentClickedMenu: (state, action: PayloadAction<string>) => {
      state.currentClickedMenu = action.payload;
      switch (action.payload) {
        case "Zilla Panchayats":
          state.dashboardData["Zilla Panchayats"] = {
            state_code: null,
            state_name: "",
            zp_lgd_code: null,
            zp_name: "",
          };
          break;

        case "Block Panchayats":
          state.dashboardData["Block Panchayats"] = {
            state_code: null,
            state_name: "",
            zp_lgd_code: null,
            zp_name: "",
            bp_lgd_code: null,
            bp_name: "",
          };
          break;

        case "Gram Panchayats":
          state.dashboardData["Gram Panchayats"] = {
            state_code: null,
            state_name: "",
            zp_lgd_code: null,
            zp_name: "",
            bp_lgd_code: null,
            bp_name: "",
            gp_lgd_code: null,
            gp_name: "",
          };
          break;

        case "Multilingual Coverage":
          state.dashboardData["Multilingual Coverage"] = {
            meeting_language: "",
            meeting_language_desc: "",
            taskId: "",
          };
          break;

        default:
          break;
      }
    },

    updateDashboardFields: (
      state,
      action: PayloadAction<{ menu: string; fields: Record<string, any> }>
    ) => {
      const { menu, fields } = action.payload;
      if (!state.dashboardData[menu]) state.dashboardData[menu] = {};
      Object.assign(state.dashboardData[menu], fields);
    },

    updateDashboardData: (
      state,
      action: PayloadAction<{ menu: string; field: string; value: any }>
    ) => {
      const { menu, field, value } = action.payload;
      if (!state.dashboardData[menu]) {
        state.dashboardData[menu] = {};
      }
      state.dashboardData[menu][field] = value;
    },

    setMeetingType: (state, action: PayloadAction<any>) => {
      state.meetingType = action.payload;
    },

    getMeetingType: (state) => {
      return state.meetingType;
    },
    setSelectedFinYear: (state, action: PayloadAction<string | null>) => {
      state.selectedFinYear = action.payload;
    },

  },
});

export const {
  getFinancialYr,
  setCurrentClickedMenu,
  updateDashboardData,
  updateDashboardFields,
  setMeetingType,
  getMeetingType,
  setSelectedFinYear,
} = commonSlice.actions;

export default commonSlice.reducer;
